/**
 * WebUtil.ts
 */
export class WebUtil {
    static getUrlParameter(name) {
        let pageUrl = window.location.href.split("?")[1];
        let value;
        if (pageUrl) {
            pageUrl = pageUrl.replace(/#[^?]+/, "");
            let urlVariables = pageUrl.split("&");
            for (let i = 0; i < urlVariables.length; i++) {
                let parameterName = urlVariables[i].split("=");
                if (parameterName[0] == name) {
                    value = decodeURIComponent(parameterName[1].replace(/\+/g, "%20"));
                }
            }
        }
        return value;
    }
    static redirect(url, parameters) {
        if (parameters) {
            url += this.createUrlParameters(parameters);
        }
        window.location.href = url;
    }
    static refresh(forced = false) {
        //The "forced" parameter is non-standard and only supported by Firefox.
        //@ts-expect-error
        window.location.reload(forced);
    }
    static open(url, parameters) {
        if (parameters) {
            url += this.createUrlParameters(parameters);
        }
        window.open(url, "_blank");
    }
    static postMessage(message, domain = "*") {
        window.top.postMessage(message, domain);
    }
    static createUrlParameters(parameters) {
        let url = "";
        for (let i = 0; i < parameters.length; i++) {
            let parameter = parameters[i];
            let prefix = i == 0 ? "?" : "&";
            url += prefix + parameter.getKey() + "=" + parameter.getValue();
        }
        return url;
    }
    static isSecure() {
        return window.location.protocol == "https:" || window.location.hostname == "localhost";
    }
}
//# sourceMappingURL=WebUtil.js.map